import storageAndCookie from '../../../global-utils/storage-and-cookies';
import { emptyNull } from '../../../shared/misc';

const parseLoginDataToCookie = (loginData) => {
  const {
    biography,
    biography_html: unused1,
    country_of_residence: unused2,
    department,
    ...partnerUser
  } = loginData?.user?.partner_user ?? emptyNull;

  return {
    ...loginData,
    user: {
      ...loginData?.user,
      partner_user: partnerUser
    }
  };
};

export const setAccessTokenAll = (loginData = emptyNull) => {
  const loginDataNew = parseLoginDataToCookie(loginData);

  storageAndCookie.set(
    'access_token_all',
    JSON.stringify(loginDataNew),
    new Date(loginDataNew.expires_at),
    true
  );
};
